import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetMessagesQuery } from './get-messages.query';
import { GetMessagesResult } from './get-messages.result';

/**
 * Get messages use case.
 * Retrieves messages for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetMessagesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetMessagesQuery): Observable<GetMessagesResult> {
    this._state.setLoadingMessages(true);
    this._state.setErrorMessages(null);

    return this._repository.getMessages(query.caseId).pipe(
      tap((messages) => {
        this._state.setMessages(messages);
        this._state.setLoadingMessages(false);
      }),
      map((messages) => ({ messages })),
      catchError((error) => {
        this._state.setErrorMessages(error.message || 'Failed to get messages');
        this._state.setLoadingMessages(false);
        return throwError(() => error);
      })
    );
  }
}
